import React from "react";
import ReactDOM from "react-dom/client";
import App from "./main";
import MetaPixelWrapper from "./components/wrapper/metaPixelWrapper";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MetaPixelWrapper pixelId={process.env.REACT_APP_PIXEL_ID}>

      <App />

    </MetaPixelWrapper>
  </React.StrictMode>
);
